<template>
    <div class="vue_wrap">
        <router-view/>
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    },
    created:async function(){
    },
    methods:{
    
    },
    watch: {
    }
}
</script>
<style scoped>
.vue_wrap{
    height: 100%;
    min-height: 100%;
    /* background-color: #fff !important; */
}
</style>